import DatePicker from 'components/base/DatePicker';
import React from 'react';
import { Card, Form, Spinner } from 'react-bootstrap';
import InterviewList from './list/InterviewList';
import { useFindRecruiterDashboardInterviewQuery } from 'service/recruiterQuery/recruiterQuery';

function Interview() {
  const today = new Date();
  const endDate = new Date(new Date().setDate(today.getDate() + 7));
  const { data = [], isLoading } = useFindRecruiterDashboardInterviewQuery('');
  return (
    <Card>
      <Card.Body className="p-2">
        <Form.Label>Select Dates</Form.Label>
        <div className="mb-3">
          <DatePicker
            options={{
              mode: 'range'
            }}
            value={[today, endDate]}
          />
        </div>
        {isLoading ? (
          <div className="d-flex justify-content-center w-100 my-4">
            <Spinner animation="border" role="status" className="me-2">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : Array.isArray(data) && data.length === 0 ? (
          <div className="text-center my-4">No entries yet</div>
        ) : (
          <InterviewList />
        )}
      </Card.Body>
    </Card>
  );
}

export default Interview;
